import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';
import { neonMap, textMap } from '../../../../components/ColorMappingOptions';

function NinaBinghattiVintage({
    language,
    snapchat = false,
    source = null
}) {
    const color = "indigo";

    const images = [
        "/assets/images/projects/binghatti-vintage/bv1.jpg",
        "/assets/images/projects/binghatti-vintage/bv2.jpg",
        "/assets/images/projects/binghatti-vintage/bv3.jpg",
        "/assets/images/projects/binghatti-vintage/bv4.jpg"
    ];

    const poster = "/assets/images/projects/binghatti-vintage/bv5.jpg";
    // const webm = "/assets/images/projects/azizi-venice/hero.webm";
    const video = "/assets/images/projects/binghatti-vintage/video.mp4";

    const {
        langs,
        langCode,
        userInfo,
        FINDESTATES_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isIraq = userInfo?.countryName == "Iraq";
    const isIran = userInfo?.countryName == "Iran";
    const isTurkey = userInfo?.countryName == "Turkey";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold neon-white">
                        {snapchat ? (
                            <>
                                احجز وحدتك الان واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية
                            </>
                        ) : (
                            <>
                                <span className={`${textMap[color]} ${neonMap[color]}`}>
                                    الوحدات محدودة ..
                                </span>
                                &nbsp;
                                سجل بياناتك الأن
                            </>
                        )}
                    </h1>
                ) : (
                    <h1 className="font-bold text-center text-xl">
                        <span className={`${textMap[color]} ${neonMap[color]} text-2xl`}>
                            Limited Units...
                        </span>
                        <br />
                        Register your details now
                    </h1>
                )}

            </>
        );
    }

    // const gridDetails = [
    //     {
    //         "topic": "أنواع الوحدات",
    //         "text": "استوديو 3,2,1 غرفة",
    //     },
    //     {
    //         "topic": "الأسعار تبدأ من",
    //         "text": isUAE ? "655,000 درهم" : "180 ألف دولار",
    //     },
    //     {
    //         "topic": "أقساط شهرية",
    //         "text": isUAE ? "6600 درهم" : "1800 دولار",
    //     },
    // ];

    const imageDetails = {
        "title": "✨ عرض حصري لفترة محدودة ✨",
        "desc": "احجز وحدتك الان واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية"
    };

    return (
        <>
            {/* LANGUAGE */}
            {/* <LanguageNavigate
                    support={["en", "ar", "fa", "tr"]}
                    redirect={{
                        en: "/projects/azizi/venice",
                        ar: "/projects/azizi/venice/ar",
                        fa: "/projects/azizi/venice/fa",
                        tr: "/projects/azizi/venice/tr",
                    }}
                /> */}
            <>
                {/* {source == "Snapchat" ? "NO OTP" : "OTP"}
                <br />
                {source} */}
            </>

            <ColorLandingPage
                color={color}
                snapchat={snapchat}
                // language={language}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                // gridDetails={gridDetails}
                imageDetails={imageDetails}
                displayAmenity={false}
                projectName={"Vintage"}
                base_url={FINDESTATES_URL}
                developer="Binghatti"
                project="Vintage"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                purpose={true}
                // enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "4 Bedrooms"]}
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={snapchat ? 101 : 6}
            />
        </>
    );
}

export default NinaBinghattiVintage;
